import React, { useState } from "react";
import styles from "./CouponCart.module.css";
import { Link } from "react-router-dom";
export default function SelectedCoupon({ data, handleRemoveFromCart }) {
  const [copied, setCopied] = useState(false);
  let bgImage = {
    background: `url(${data?.bgImage}) top center / cover`,
  };
  const originalDate = data?.validTill;
  const date = new Date(originalDate);
  const options = { day: "numeric", month: "short", year: "numeric" };
  const formattedDate = date?.toLocaleDateString("en-US", options);

  function copyLink() {
    let copyText = "";
    if (data?.type == "GENERATE") {
      copyText = data?.generatedCoupon;
    } else {
      copyText = data?.couponCode;
    }
    setCopied(true);
    setTimeout(() => {
      let onlineStore = data?.cpnUsability?.find((el) => el?.id == "online");
      if (onlineStore?.isUsable && onlineStore?.link) {
        window.open(onlineStore?.link);
      }
      setCopied(false);
    }, [1000]);
    navigator.clipboard.writeText(copyText);
    window.document.execCommand("copy");
    // alert(copyText + "\n copied to clipboard")
  }

  return (
    <>
      <div
        className={`${styles.selectedCoupon} grid sm:grid-cols-2 grid-cols-1 sm:gap-[15px] sm:p-[20px] sm:border-[1px] sm:border-[#DFDFDF]`}
      >
        <div
          className={`m-[10px] sm:m-0 ${styles.couponParent1}`}
          key={data?._id}
        >
          <div style={bgImage} className="h-[180px] w-full" />
          <div className="p-[10px] relative w-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="297"
              height="201"
              viewBox="0 0 297 201"
              fill="none"
              className="left-0 top-[-70px] w-full absolute z-0"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 3.20292C7.66005 7.17773 15.4548 10.6201 23.309 13.4392C54.1609 22.6469 80.4671 15.6988 106.468 8.83132C137.019 0.762081 167.149 -7.19596 203.738 11.2955C215.86 17.4192 227.481 25.7393 239.193 34.124C252.378 43.5644 265.678 53.0866 279.937 59.6478C285.512 62.1978 291.232 64.4058 297 66.2794V191.162C297 196.133 292.971 200.162 288 200.162H8.99999C4.02943 200.162 0 196.133 0 191.162V3.20292Z"
                fill="white"
              />
            </svg>
            <div className="relative z-1 mt-[-85px]">
              {data?.limited ? (
                <p className={styles.limitedOffer}>Limited Offer</p>
              ) : (
                <div className="h-[40px]" />
              )}
              <h3>{data?.offerText}</h3>
              <p>{data?.conditionText}</p>
              <div className="flex mt-[20px] itams-center justify-between">
                {formattedDate && (
                  <h4>
                    Valid Till: <span>{formattedDate}</span>
                  </h4>
                )}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="27"
                  viewBox="0 0 26 27"
                  fill="none"
                  onClick={() => handleRemoveFromCart(data)}
                  className="cursor-pointer"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.53333 21.3C8.09813 21.3 6.93333 22.4648 6.93333 23.9C6.93333 25.3352 8.09813 26.5 9.53333 26.5C10.9685 26.5 12.1333 25.3352 12.1333 23.9C12.1333 22.4648 10.9685 21.3 9.53333 21.3ZM18.2 21.3C16.7648 21.3 15.6 22.4648 15.6 23.9C15.6 25.3352 16.7648 26.5 18.2 26.5C19.6352 26.5 20.8 25.3352 20.8 23.9C20.8 22.4648 19.6352 21.3 18.2 21.3ZM9.53333 23.0333C10.0117 23.0333 10.4 23.4216 10.4 23.9C10.4 24.3784 10.0117 24.7667 9.53333 24.7667C9.05493 24.7667 8.66667 24.3784 8.66667 23.9C8.66667 23.4216 9.05493 23.0333 9.53333 23.0333ZM18.2 23.0333C18.6784 23.0333 19.0667 23.4216 19.0667 23.9C19.0667 24.3784 18.6784 24.7667 18.2 24.7667C17.7216 24.7667 17.3333 24.3784 17.3333 23.9C17.3333 23.4216 17.7216 23.0333 18.2 23.0333ZM15.6719 4.83333H4.09153L3.62007 3.41893C3.38347 2.71086 2.72133 2.23333 1.97513 2.23333C1.47853 2.23333 0.866667 2.23333 0.866667 2.23333C0.388267 2.23333 0 2.6216 0 3.1C0 3.5784 0.388267 3.96667 0.866667 3.96667H1.97513L2.63727 5.95133L5.22773 15.4526L5.7642 17.5976C6.05367 18.7546 7.09366 19.5667 8.28706 19.5667H20.8C21.2784 19.5667 21.6667 19.1784 21.6667 18.7C21.6667 18.2216 21.2784 17.8333 20.8 17.8333H8.28706C7.88926 17.8333 7.5426 17.5629 7.44554 17.1773L7.17687 16.1H19.4757C20.6483 16.1 21.6762 15.3157 21.9847 14.1838L22.9519 10.6365C22.9719 10.5646 22.9814 10.4918 22.9823 10.4207C24.7633 9.5948 26 7.7904 26 5.7C26 2.83047 23.6695 0.5 20.8 0.5C18.2251 0.5 16.0853 2.37547 15.6719 4.83333ZM15.6719 6.56667H4.60113L6.7288 14.3667H19.4757C19.8666 14.3667 20.2089 14.1049 20.3121 13.7279L21.086 10.8922C20.9915 10.8974 20.8962 10.9 20.8 10.9C18.2251 10.9 16.0853 9.02453 15.6719 6.56667ZM20.8 2.23333C22.7136 2.23333 24.2667 3.7864 24.2667 5.7C24.2667 7.6136 22.7136 9.16667 20.8 9.16667C18.8864 9.16667 17.3333 7.6136 17.3333 5.7C17.3333 3.7864 18.8864 2.23333 20.8 2.23333ZM19.9333 4.83333H19.0667C18.5883 4.83333 18.2 5.2216 18.2 5.7C18.2 6.1784 18.5883 6.56667 19.0667 6.56667H19.9333H20.8C20.3216 6.56667 21.5 6.56667 20.8 6.56667C21.2784 6.56667 19.4757 6.56667 19.9333 6.56667H21.6667H22.5333C23.0117 6.56667 23.4 6.1784 23.4 5.7C23.4 5.2216 23.0117 4.83333 22.5333 4.83333H21.6667H19.9333C19.5 4.83333 21.2784 4.83333 20.8 4.83333C20.3216 4.83333 21.8633 4.83333 21.6667 4.83333H19.9333Z"
                    fill="black"
                  />
                </svg>
              </div>
              {copied ? (
                <button>Copied</button>
              ) : (
                <button onClick={copyLink}>
                  {data?.generatedCoupon || data?.couponCode}
                </button>
              )}
            </div>
          </div>
        </div>
        <div
          className={`${styles.selectedDetails}  flex-col justify-between hidden sm:flex`}
        >
          <div>
            <h3>Coupon applicable for the following products:</h3>
            <p className="mb-[10px]">{data?.cpnApplicableProduct}</p>
            <div className="mb-[10px]">
              <h3>Coupon usability:</h3>
              {data?.cpnUsability?.map((obj) => {
                return (
                  <div className="flex items-center gap-[20px]">
                    <div className="flex items-center gap-[5px]">
                      {obj?.isUsable ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 16 12"
                          fill="none"
                        >
                          <path
                            d="M1 6L5.667 11L15 1"
                            stroke="#55A226"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0.292923 1.70714C-0.0976171 1.31663 -0.0976448 0.683464 0.292863 0.292923C0.683371 -0.0976175 1.31654 -0.0976446 1.70708 0.292863L5.60509 4.19054L9.5031 0.292863C9.89364 -0.0976446 10.5268 -0.0976175 10.9173 0.292923C11.3078 0.683464 11.3078 1.31663 10.9173 1.70714L7.01936 5.60469L10.9172 9.50218C11.3077 9.89269 11.3077 10.5259 10.9172 10.9164C10.5267 11.3069 9.89357 11.307 9.50303 10.9165L5.60509 7.01885L1.70715 10.9165C1.31661 11.307 0.68344 11.3069 0.292933 10.9164C-0.0975747 10.5259 -0.0975477 9.89269 0.292993 9.50218L4.19081 5.60469L0.292923 1.70714Z"
                            fill="#F85959"
                          />
                        </svg>
                      )}
                      <p>{obj?.type}</p>
                    </div>
                    {obj?.isUsable && obj?.link && (
                      <Link
                        className="flex items-center gap-[5px] text-[#56565d]"
                        to={obj?.link}
                        target="_blank"
                      >
                        {obj?.id == "online" && "go to store"}
                        {obj?.id == "offline" && " view address"}
                        <svg
                          width="15px"
                          height="15px"
                          viewBox="0 0 100 100"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.8333 12.5C16.2789 12.5 12.5 16.2789 12.5 20.8333V79.1667C12.5 83.7211 16.2789 87.5 20.8333 87.5H79.1667C83.7211 87.5 87.5 83.7211 87.5 79.1667V50H79.1667V79.1667H20.8333V20.8333H50V12.5H20.8333ZM58.3333 12.5V20.8333H73.2747L34.554 59.554L40.446 65.446L79.1667 26.7253V41.6667H87.5V12.5H58.3333Z"
                            fill="#56565d"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {data?.note && (
            <h3>
              Note: <span style={{ fontWeight: 400 }}>{data?.note}</span>
            </h3>
          )}
        </div>
      </div>
    </>
  );
}
